import React, { ReactElement } from 'react';
import ContractLayout from 'pricing/components/contract/contractLayout/ContractLayout';
import ContractViewContent from 'pricing/pages/contractView/contractViewContent/ContractViewContent';

function ContractView(): ReactElement {
  return (
    <ContractLayout>
      <ContractViewContent />
    </ContractLayout>
  );
}

export default ContractView;
